import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { reducer as toastrReducer } from "react-redux-toastr";
import { reducer as formReducer } from "redux-form";

import UIsettings from "./modules/UIsettings";
import autocomplete from "./modules/autocomplete";
import file from "./modules/file";
import options from "./modules/options";
import StickersOptions from "./modules/StickersOptions";
import CrulesOptions from "./modules/CrulesOptions";
import auth from "./modules/auth";
import profile from "./modules/profile";
import users from "./modules/users";
import articles from "./modules/articles";
import distributors from "./modules/distributors";
import downloads from "./modules/downloads";
import bannedCashregisters from "./modules/banned-cashregisters";
import eventTypes from "./modules/event-types";
import events from "./modules/events";
import cashregisters from "./modules/cashregisters";
import incomingSms from "./modules/incoming-sms";
import outgoingSms from "./modules/outgoing-sms";
import stickers from "./modules/stickers";
import exams from "./modules/exams";
import listItemsSms from "./modules/list-items-sms";
import distributor from "./modules/distributor";
import annualReviews from "./modules/annual-reviews";
import cashregisterRights from "./modules/cashregister-rights";
import examineeExams from "./modules/examinee-exams";
import myExams from "./modules/myExams";
import home from "./modules/home";
import fcm from "./modules/fcm";
import notifications from "./modules/notifications";
import serviceOrders from "./modules/service-orders";
import clients from "./modules/clients";
import worksheets from "./modules/worksheets";
import signing from "./modules/signing";
import workfees from "./modules/workfees";
import crules from "./modules/crules";
import slider from "./modules/slider";
import catalog from "./modules/catalog";
import cart from "./modules/cart";
import product from "./modules/product";
import serviceChanges from "./modules/service-changes";
import adminProducts from "./modules/admin-products";
import adminTags from "./modules/admin-tags";
import orders from "./modules/orders";
import anyk from "./modules/anyk";
import shopCart from "./modules/shopCart";
import shopOrder from "./modules/shopOrder";
import cashregistersWorksheets from "./modules/cashregisters-worksheets";

const appReducers = {
  UIsettings,
  autocomplete,
  file,
  options,
  auth,
  profile,
  users,
  articles,
  serviceChanges,
  distributors,
  downloads,
  bannedCashregisters,
  events,
  eventTypes,
  cashregisters,
  incomingSms,
  outgoingSms,
  stickers,
  exams,
  listItemsSms,
  distributor,
  annualReviews,
  cashregisterRights,
  examineeExams,
  myExams,
  ...{ homeDashBoard: home.dashboard, homeEvents: home.events },
  fcm,
  notifications,
  serviceOrders,
  clients,
  worksheets,
  signing,
  StickersOptions,
  CrulesOptions,
  workfees,
  crules,
  slider,
  cart,
  product,
  catalog,
  adminProducts,
  adminTags,
  orders,
  anyk,
  cashregistersWorksheets,
  shopCart,
  shopOrder
};

const reducers = combineReducers({
  ...appReducers,
  routing: routerReducer,
  form: formReducer,
  toastr: toastrReducer
});

export default reducers;



// WEBPACK FOOTER //
// ./src/redux/reducers.js